module.exports = __webpack_public_path__ + "media/images/gameover-d9ad4ff505b8d018686560f6f5d8d44f.jpg";